import React, { useEffect, useState } from 'react';
import { Divider, Text, VStack } from '@chakra-ui/react';
import { BookingParams } from '../../types/BookingTypes';
import {
  createBooking,
  getBookingConfirmationIntroduction,
} from '../../services/Booking/BookingService';
import { SingleObject } from '../../types/ObjectTypes';

export interface BookingConfirmationProps {
  bookingParams: BookingParams;
  object: SingleObject;
}

export const BookingConfirmation = (props: BookingConfirmationProps): JSX.Element => {
  const { bookingParams } = props;
  const { customer } = bookingParams;
  const { Salutation, Title, Firstname, Lastname } = customer;
  const bookingConfirmationIntroduction = getBookingConfirmationIntroduction({
    Salutation,
    Title,
    Firstname,
    Lastname,
  });
  const [headerBookingConfirmationText, setHeaderBookingConfirmationText] = useState('');

  useEffect(() => {
    (async function () {
      await createBooking(bookingParams);
    })();
    if(bookingParams.Type == "OFFER") {
      setHeaderBookingConfirmationText("Buchungsbestätigung");
    }
    if(bookingParams.Type == "OFFER") {
      setHeaderBookingConfirmationText("ANGEBOT erstellt");
    }

  }, [bookingParams]);

  useEffect(() => {
    const scrollTarget = document.getElementById('confirmationHeader') as HTMLElement;
    if(scrollTarget != null){
        scrollTarget.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <VStack
      p={4}
      borderRadius={{ sm: 0, md: 4, lg: 4, xl: 4 }}
      borderWidth={1}
      borderColor={'gray.300'}
      backgroundColor={'white'}
      minW="100%"
      gridGap={4}
      id={'confirmationHeader'}
      >
      <Text w={'100%'} textAlign={'left'} fontSize={'xl'} textStyle={'category.primary'}>      
        {headerBookingConfirmationText}
      </Text>
      <Divider />
      <VStack alignItems={'baseline'} gridGap={8}>
        <Text>{bookingConfirmationIntroduction}</Text>
        {bookingParams.Type == "OFFER"
        ? (<React.Fragment>
            <Text>
              vielen Dank für Ihr Interesse. Das Angebot wurde soeben an Ihre Mail-Adresse gesendet. Sollten Fragen sein, zögern
              Sie bitte nicht. Schreiben Sie uns oder rufen Sie uns gerne an.
              <br />
              Wir freuen uns auf Ihre Buchung und wünschen Ihnen jetzt schon einen schönen Urlaub.
            </Text>
          </React.Fragment>)
        : (<React.Fragment>
            <Text>
              vielen Dank für Ihre Buchung. Ihre Buchungsbestätigung haben Sie soeben per E-Mail
              erhalten. Bitte lesen Sie auch diese nochmals genau durch. Diese ist verbindlich für Ihren
              Buchungsvertrag. Sollte etwas nicht korrekt sein, dann schreiben Sie uns eine E-Mail oder
              rufen Sie uns am besten gleich an.
            </Text>
            <Text>Bitte beachten Sie auch die aufgeführten Zahlungstermine.</Text>
            <Text>Wir danken für Ihre Buchung und wünschen Ihnen einen schönen Aufenthalt.</Text> 
          </React.Fragment>)
      }     
      </VStack>
    </VStack>
  );
};
